import type { SVGProps } from 'react'

export function Star(props: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
      <path
        fill="currentColor"
        d="m14.64 7.18-2.8 2.43.85 3.62a1.03 1.03 0 0 1-1.53 1.12L8 12.4l-3.16 1.94a1.02 1.02 0 0 1-1.53-1.12l.86-3.62-2.81-2.43a1.03 1.03 0 0 1 .58-1.8l3.69-.3 1.42-3.44a1.02 1.02 0 0 1 1.9 0l1.42 3.44 3.68.3a1.03 1.03 0 0 1 .59 1.8Z"
      />
    </svg>
  )
}
